






























































































































































































import Vue from 'vue';
import {
  ActivityGroup,
  ActivitySubtype,
  ActivityType,
  GeekItem,
  GeekItemWithActivityQuantity,
  TranslatedActivitySubtype,
  TranslatedActivityType,
} from '@/models';
import {buildGeekName, ToastsService} from '@/utils';
import Multiselect from 'vue-multiselect';
import {AllGeeksMultipleSelect} from '@/components';
import {Actions, typedStore} from '@/store';
import {asyncSelectMixin, collapseMixin} from '@/shared';
import mixins from 'vue-typed-mixins';
import {GrantActivityToGeek, GrantActivityToMultipleGeeks} from '@/models/admin-panel';

export default mixins(asyncSelectMixin(Actions.geek.resetGeeks, Actions.geek.fetchGeeks), collapseMixin).extend({
  name: 'AddActivityTab',
  components: {
    AllGeeksMultipleSelect,
    Multiselect,
  },
  data() {
    return {
      selectedGeeks: [] as GeekItemWithActivityQuantity[],
      activity: (null as unknown) as ActivityType,
      subactivity: (null as unknown) as ActivitySubtype,
      reason: '',
      loader: {
        isRequestAddActivityPending: false,
        isActivityRequestListPending: false,
      },
    };
  },
  async created(): Promise<void> {
    await this.$store.dispatch(Actions.activities.fetchAll);
    try {
      await this.$store.dispatch(Actions.activities.fetchRequests);
    } finally {
      this.loader.isActivityRequestListPending = false;
    }
  },
  computed: {
    loadingStatus(): boolean {
      return this.loader.isRequestAddActivityPending;
    },
    activities(): ActivityGroup[] {
      return typedStore(this).state.activities.all.map(activityGroup => {
        return {
          skill: activityGroup.skill,
          activityTypes: activityGroup.activityTypes.map(activityType => {
           return {
            ...activityType,
            translatedName: this.$t(`activity.types.${activityType.name}.name`),
           } as TranslatedActivityType;
          }),
        } as ActivityGroup;
      });
    },
    hasSelectedActivitySubtypes(): boolean {
      return this.activity && (this.activity.subtypes as ActivitySubtype[]).length > 0;
    },
    subactivityValidationRules(): boolean {
      return this.hasSelectedActivitySubtypes;
    },
    activitySubtypes(): TranslatedActivitySubtype[] {
      return (this.activity && this.activity.subtypes || []).map(x => {
        return {
          ...x,
          translatedName: this.$t(`activity.subtypes.${x.name}.name`),
        } as TranslatedActivitySubtype;
      });
    },
    isActivityRequired(): boolean {
      return this.selectedGeeks.length ? true : false;
    },
  },
  methods: {
    async addActivity() {
      const isFormValid = await this.$validator.validate();
      if (!isFormValid) {
        return;
      }

      const grantActivityToGeeks: GrantActivityToGeek[] = [];
      for (const item of this.selectedGeeks) {
        const grantActivityToGeek: GrantActivityToGeek = {
          activityTypeId: this.activity.id,
          activitySubtypeId: this.subactivity?.id,
          geekId: item.id,
          reason: this.reason,
          activityQuantity: item.activityQuantity,
        };
        grantActivityToGeeks.push(grantActivityToGeek);
      }
      this.loader.isRequestAddActivityPending = true;
      try {
        await this.$store.dispatch(
            Actions.activities.postGeekActivityRequests,
            { models: grantActivityToGeeks } as GrantActivityToMultipleGeeks,
        );
        ToastsService.success(this.$t('admin-panel.activities.tabs.add.activity-success-message') as string);
        this.loader.isRequestAddActivityPending = false;
        this.loader.isActivityRequestListPending = true;
        this.resetForm();
        await this.$validator.reset();
        (this as any).$refs.geekSelect.clearSelected();
      } finally {
        this.loader.isRequestAddActivityPending = false;
      }
    },
    async updateSelectedGeeks(geekItems: GeekItem[]): Promise<void> {
      const newSelectedGeeks = [] as GeekItemWithActivityQuantity[];
      geekItems.forEach(item => {
        const geek = this.selectedGeeks.find(g => g.id === item.id);
        if (geek) {
          newSelectedGeeks.push(geek);
        } else {
          const newItem = item as GeekItemWithActivityQuantity;
          newItem.activityQuantity = 1;
          newSelectedGeeks.push(newItem);
        }
      });
      this.selectedGeeks = newSelectedGeeks;
      await this.$validator.reset();
    },
    changeAddActivityLoaderStatus(status: boolean): void {
      this.loader.isRequestAddActivityPending = status;
    },
    removeGeek(geek: GeekItem): void {
      (this as any).$refs.geekSelect.deleteGeek(geek);
    },
    increase(geek: GeekItemWithActivityQuantity): void {
      const geekIndex = this.selectedGeeks.findIndex(a => a.id === geek.id);
      geek.activityQuantity++;
      Vue.set(this.selectedGeeks, geekIndex, geek);
    },
    decrease(geek: GeekItemWithActivityQuantity): void {
      if (geek.activityQuantity > 1) {
        const geekIndex = this.selectedGeeks.findIndex(a => a.id === geek.id);
        geek.activityQuantity--;
        Vue.set(this.selectedGeeks, geekIndex, geek);
      }
    },
    clearSubactivity() {
      this.subactivity = (null as unknown) as ActivitySubtype;
    },
    resetForm() {
      this.activity = (null as unknown) as ActivityType;
      this.subactivity = (null as unknown) as ActivitySubtype;
      this.reason = '';
      this.selectedGeeks = [] as GeekItemWithActivityQuantity[];
    },
    buildGeekName,
  },
});

